import { myIpAddress } from "config";
import { customAxios } from '../../axios/CustomAxios'

/**
 * 추가 복지포인트 이력 리스트 조회
 * 서버 엔드포인트: POST /wp/v2/addPoint/list
 * - 파라미터는 서버 지원 여부에 따라 선택적으로 전달됩니다.
 * - 기본적으로 연도(year)와 검색어(keyword)를 전달하며,
 *   서버가 페이징/정렬을 지원하면 page, pageSize, orderBy, order도 전달합니다.
 */
const wpAddPointList = async ({
  year,
  keyword,
  page,
  pageSize,
  orderBy,
  order,
} = {}) => {
  const params = {};
  if (year) params.year = year;
  if (keyword) params.keyword = keyword;
  if (page) params.page = page;
  if (pageSize) params.pageSize = pageSize;
  if (orderBy) params.orderBy = orderBy;
  if (order) params.order = order;

  return customAxios.get(`${myIpAddress}/wp/v2/addPoint/list`,{
    params,
  });
};

export default wpAddPointList;
